export default __webpack_public_path__ + "static/char-s-21-ko-4f125823aee78c5af74eedc71bd4fadf.png";